<app-header></app-header>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple"></ngx-spinner>
<div class="form-group col-md-10 mar-top-10 ">
  <div class="head_title">{{'Supplier Parts Database (Approved Parts)' | translate}}</div>
</div>
<form name="form" (ngSubmit)="this.onChangeTable(this.config, true)" #f="ngForm" novalidate>
  <div class="row no-mar-lr">
    <div class="form-group col-md-2 mar-top-30 mar-rgt-40  mar-lft-30">
      <label>{{'Select Next Process' | translate}}</label>
      <!-- <angular2-multiselect *ngIf="lineCodeList"  name="lineNumbers" [data]="lineCodeList"
        [(ngModel)]="lineNumbers" name="lineNumbers" [settings]="settingsoperation" (onSelect)="onSingleSelectOperation($event)"
        (onDeSelect)="onDeSelectOperation($event)" (onSelectAll)="onSelectAllOperation($event)" (onDeSelectAll)="DeSelectAllOperation($event)"></angular2-multiselect> -->
        <ng-multiselect-dropdown *ngIf="lineCodeList"  name="lineNumbers"  [settings]="settingsoperation" [data]="lineCodeList" [(ngModel)]="lineNumbers"(onSelect)="onSingleSelectOperation($event)"
          (onDeSelect)="onDeSelectOperation($event)" (onSelectAll)="onSelectAllOperation($event)" (onDeSelectAll)="DeSelectAllOperation($event)"
          ></ng-multiselect-dropdown>
    </div>

    <div class="form-group col-md-2 mar-top-30 mar-rgt-40">
      <label>{{'Select Delivery Point' | translate}}</label>
      <!-- <angular2-multiselect *ngIf="deliveryCodeList"  name="deliveryPoints" [(ngModel)]="deliveryPoints"
        name="deliveryPoints" [data]="deliveryCodeList" [settings]="settingsdelieverypoint" (onSelect)="onSingleSelectdeliverypoint($event)"
        (onDeSelect)="onDeSelectdeliverypoint($event)" (onSelectAll)="onSelectAlldeliverypoint($event)" (onDeSelectAll)="DeSelectAlldeliverypoint($event)"></angular2-multiselect> -->
        <ng-multiselect-dropdown *ngIf="deliveryCodeList"  name="deliveryPoints"  [settings]="settingsdelieverypoint" [data]="deliveryCodeList" [(ngModel)]="deliveryPoints"(onSelect)="onSingleSelectdeliverypoint($event)"
        (onDeSelect)="onDeSelectdeliverypoint($event)" (onSelectAll)="onSelectAlldeliverypoint($event)" (onDeSelectAll)="DeSelectAlldeliverypoint($event)"
        ></ng-multiselect-dropdown>
    </div>
    <div class="form-group col-md-2 mar-top-30">
      <button type="submit" [disabled]="userIDTaken && userIDTaken" value="Register" class="btn btn-dark ">
        {{'Search' | translate}}
      </button>
    </div>
  </div>
</form>

<div class="row no-mar-lr">
  <div class="col-md-10 mar-btm-30 mar-lft-30 ">
    <!-- <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page" [totalItems]="length"
      [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
      (numPages)="numPages = $event">
    </pagination> -->
    <section class="part_search_bar">
      <div class="row ">
        <div class="col-md-7 search_input">
          <div class="input-group">
            <input placeholder="{{'SEARCHBY' | translate}}"
              class="form-control" [(ngModel)]="searchInput" >
            <span class="input-group-btn">
              <button class="btn btn-light" type="button" (click)="onChangeTable(config)"  [disabled]="rows.length <= 0">
                {{'Search' | translate}}
              </button>
            </span>
          </div>
        </div>
        <div class="col-md-4">
          <button [disabled]="notallowed" class="row_title btn btn-dark" (click)="exportCSV()">
            {{'Export Approved Parts' | translate}}
          </button>
        </div>
      </div>
    </section>
    
    <!-- <ng-table [config]="config" (tableChanged)="onChangeTable(config)" (cellClicked)="onCellClick($event)" [rows]="rows"
      [columns]="columns">
    </ng-table> -->


    <pagination *ngIf="config.paging" class="pad-top-10" [(ngModel)]="page" [totalItems]="length"
      [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
      (numPages)="numPages = $event">
    </pagination>
    
    <div class="example-container mat-elevation-z8">
    
      <mat-table [dataSource]="dataSource" >
    
       
        <ng-container matColumnDef="partNumber">
          <mat-header-cell *matHeaderCellDef > Part Number </mat-header-cell>
          <mat-cell *matCellDef="let row"> <a target="blank" class="partno_column" [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active">{{row.partNumber}}</a>  </mat-cell>
        </ng-container>
    
        
        <ng-container matColumnDef="partName">
          <mat-header-cell *matHeaderCellDef > Part Name </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.partName}} </mat-cell>
        </ng-container>
    
       
        <ng-container matColumnDef="packageId">
          <mat-header-cell *matHeaderCellDef > PackageId </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.packageId}} </mat-cell>
        </ng-container>
    
     
        <ng-container matColumnDef="deliveryPoint">
          <mat-header-cell *matHeaderCellDef > Delivery Point </mat-header-cell>
          <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.deliveryPoint}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nextProcess">
          <mat-header-cell *matHeaderCellDef > Next Process </mat-header-cell>
          <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.lineNumber}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="assignedDate">
          <mat-header-cell *matHeaderCellDef > Assigned Date </mat-header-cell>
          <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.assignedDate}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dueDate">
          <mat-header-cell *matHeaderCellDef > Due Date </mat-header-cell>
          <mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.dueDate}} </mat-cell>
        </ng-container>
    
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
      </mat-table>
    
    
    </div>
    

    <div *ngIf="rows.length <= 0" class="tbl_noRecord">
      {{'No Records Found' | translate}}
    </div>
    <!--
      <pre *ngIf="config.paging" class="card card-block card-header">Page: {{page}} / {{numPages}}</pre>
    -->
  </div>
</div>